import axios from "@/axios";

    export const namespaced = true
    
    export const state = {
        organization:{},
        allOrganizations: [],
        jointStaffOrganizations: [],
        filteredOrganizations:[],
        flattenedOrganizations: [],
        partnerNationOrganizations: [],
        countryOrganizations: [],
        usOrganizations: [],
        signatureOrganizations: [],
        paginatedOrganizations: []
    }

    export const default_organization = {
        id: 0, 
        name: '',
        abbreviation: '',
        countryId: 0,
        parentId: 0,
        serviceName: "",
        website: "",
        createDate: null,
        updateDate: null,
        isActive: false,
        children: []
    }

    export const getters = {
        organization: state => state.organization,
        filteredOrganizations: state => state.filteredOrganizations, 
        flattenedOrganizations: state => state.flattenedOrganizations,
        allOrganizations: (state) => { return state.allOrganizations },
        paginatedOrganizations: (state) => state.paginatedOrganizations,
        partnerNationOrganizations: (state) => { return state.partnerNationOrganizations },
        jointStaffOrganizations: (state) => { return state.jointStaffOrganizations},
        countryOrganizations: (state) => { return state.countryOrganizations},
        usOrganizations: (state) => { return state.usOrganizations},
        signatureOrganizations: (state) => { return state.signatureOrganizations},
    }

    export const mutations = {

        SET_ORGANIZATION: (state, response) => (state.organization =  Object.assign({}, response.data)),
        SET_USER_ORGANIZATION: (state, response) => (state.organization =  Object.assign({}, response.data)),
        RESET_ORGANIZATION: (state) => (state.organization =  default_organization),
        SET_ALL_ORGANIZATIONS: (state, response) => (state.allOrganizations = response.data),
        SET_FILTERED_ORGANIZATIONS: (state, response) => (state.filteredOrganizations = [response.data]),
        SET_FLATTENED_ORGANIZATIONS: (state, response) => (state.flattenedOrganizations = response.data),
        SET_PAGINATED_ORGANIZATIONS: (state, response) => (state.paginatedOrganizations = response.data),
        SET_JOINT_STAFF_ORGANIZATIONS: (state, response) => (state.jointStaffOrganizations = [response.data]),
        SET_PARTNER_NATION_ORGANIZATIONS: (state, response) => (state.partnerNationOrganizations = [response.data]),
        SET_COUNTRY_ORGANIZATIONS: (state, response) => (state.countryOrganizations = response.data),
        SET_US_ORGANIZATIONS: (state, response) => (state.usOrganizations = response.data),
        SET_SIGNATURE_ORGANIZATIONS: (state, response) => (state.signatureOrganizations = response.data)
    }
    
    export const actions = {
        async getOrganization({ state, commit }, id) {
            if (id == 0) {
                commit('RESET_ORGANIZATION')
            }
            commit('SET_ORGANIZATION', await axios.get("/api/organizations/id/" + id))
        },
        async getOrganizations({ commit }) {
            const response = await axios.get("/api/organizations");
            commit("SET_ALL_ORGANIZATIONS", response)
        },
        async deleteOrganizations({ commit },id) {
            const response = await axios.delete("/api/organizations/" + id);
        },
        async getPaginatedOrganizations({ commit, state }, apiInfo) {
            let response = await axios.post(`api/organizations/search/paginated`, apiInfo, { config: {showToast: false} });
            
            commit("SET_PAGINATED_ORGANIZATIONS", response)
          },
          async getAllOrganizations({ commit }, apiInfo) {
            commit("SET_ALL_ORGANIZATIONS",  await axios.post(`api/organizations/search`, apiInfo))
          },
        async updateOrganization({ commit,state}) {
            await axios.post("/api/organizations/", state.organization).then(() => {
                commit('SET_ORGANIZATION' ,{})
            })
        },
        async saveOrganization({ commit,state}, isActive) {
            let org = {...state.organization};
            if(isActive !== undefined) {
                org.isActive = isActive;
            }
            await axios.post("/api/organizations/", org);
        },
        async getJointStaffOrganizations({ commit }, inculdeDisabled = false) {
            let all = (!inculdeDisabled) ? "" : "/all";
           
            const response = await axios.get(`/api/organizations/jointstafftree${all}`);
            commit("SET_JOINT_STAFF_ORGANIZATIONS", response)
        },
        async getPartnerNationOrganizations({ commit }) {
            const response = await axios.get("/api/organizations/partnernationtree");
            commit("SET_PARTNER_NATION_ORGANIZATIONS", response)
        },
        async getFilteredOrganizations({ commit }, parentId) {
            const response = await axios.get(`/api/organizations/filteredtree/${parentId}`);
            commit("SET_FILTERED_ORGANIZATIONS", response)
        },
        async getFlattenedOrganizations({ commit }, parentId) {
            const response = await axios.get("/api/organizations/flattenedtree");
            commit("SET_FLATTENED_ORGANIZATIONS", response)
        },
        async getSignatureOrganizations({ commit }, uri) {
            const response = await axios.get(uri);
            commit("SET_SIGNATURE_ORGANIZATIONS", response)
        },
        async getCountryOrganizations({ commit }, countryId) {
            const response = await axios.get("/api/organizations/countryId/" + countryId );
            commit("SET_COUNTRY_ORGANIZATIONS", response)
            return true;
        },
        async getUsOrganizations({ commit }) {
            const response = await axios.get("/api/organizations/countrycode/US");
            commit("SET_US_ORGANIZATIONS", response)
        },
        async getUserOrganization({ commit }, userId) {
            const response = await axios.get(`/api/organizations/user/${userId}`);
            commit("SET_USER_ORGANIZATION", response)
        },
        async toggleOrganization({ commit }, organizationId) {
            const response = await axios.get(`/api/organizations/toggle/state/${organizationId}`);
            return true;
        },
    }